import { join } from 'ramda';
import { getLeaderboardWorkoutsDetails } from '@engage/api-v2';
import { engageApi } from '../lib/singletons';
import { unwrap } from '../lib/unwrap';
import { toFetcher } from './toFetcher';
export var toPostclassLeaderboardFetchers = function toPostclassLeaderboardFetchers() {
  var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : engageApi;
  return {
    GetLeaderboardWorkoutsDetails: toFetcher(function (_ref) {
      var workoutIds = _ref.workoutIds;
      return "GetLeaderboardWorkoutDetails".concat(join(',', workoutIds));
    }, function (_ref2) {
      var workoutIds = _ref2.workoutIds;
      return unwrap(function () {
        return getLeaderboardWorkoutsDetails(api, {
          ids: workoutIds
        });
      });
    })
  };
};